import styled from 'styled-components'

/*
 * A "comet" sweeping across a faint track, in the tenant's own brand colour
 * (theme.palette.primary — the app is white-labelled, so nothing here is a fixed
 * hex). It fades in and out with opacity rather than mounting and unmounting, so
 * the transition is what a recruiter sees instead of a hard cut.
 */
export const Bar = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 3px;
	/* Above the impersonation banner (1250) too, or the bar vanishes while viewing as someone. */
	z-index: 1260;
	pointer-events: none;
	overflow: hidden;
	background: ${({ theme }) => `${theme.palette.primary.main}1f`};
	opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	transition: opacity 220ms ease;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		left: -40%;
		width: 40%;
		background-image: ${({ theme }) => {
			const accent = theme.palette.primary.sub || theme.palette.primary.main
			return `linear-gradient(90deg, transparent, ${accent}, ${theme.palette.primary.main}, ${accent}, transparent)`
		}};
		box-shadow: ${({ theme }) => `0 0 8px ${theme.palette.primary.main}99`};
		animation: ${({ $visible }) => ($visible ? 'mv-top-loading-sweep 1.1s ease-in-out infinite' : 'none')};
	}

	@keyframes mv-top-loading-sweep {
		from {
			left: -40%;
		}
		to {
			left: 100%;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		&::after {
			animation: none;
			left: 0;
			width: 100%;
			opacity: 0.6;
		}
	}
`
